module.exports = __webpack_public_path__ + "img/Multi-account-4.29e29681.png";